exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ServiceTerms_service_2ZSx {\n  margin-bottom: 24px;\n\n  display: grid;\n\n  grid-row-gap: 16px;\n}\n.ServiceTerms_service__element_5IlA {\n    display: grid;\n    grid-template-rows: auto;\n    grid-row-gap: 4px;\n  }\n@media (min-width: 768px) {\n  .ServiceTerms_service__element_5IlA {\n    grid-template-columns: 20% 80%;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"service": "ServiceTerms_service_2ZSx",
	"service__element": "ServiceTerms_service__element_5IlA"
};